import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledContentDivider = styled.div`
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
    width: 100%;
`;
